// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".filter-item-header {\n  display: flex;\n  justify-content: space-between;\n  cursor: pointer;\n  font-weight: bold;\n  padding: 11px 0px;\n}\n", ""]);
// Exports
module.exports = exports;
